import React from "react";
import Layout from "../layout/layout";
import "./Carriers.css";

import p1 from "../images/carriers/1.png";
import p2 from "../images/carriers/2.png";
import p3 from "../images/carriers/3.png";
import p4 from "../images/carriers/4.png";
import p5 from "../images/carriers/5.png";
import p6 from "../images/carriers/6.png";
import p7 from "../images/carriers/7.png";
import p8 from "../images/carriers/8.png";
import p9 from "../images/carriers/9.png";
import p10 from "../images/carriers/10.png";
import p11 from "../images/carriers/11.png";
import p12 from "../images/carriers/12.png";
import p13 from "../images/carriers/13.png";
import p14 from "../images/carriers/14.png";
import p15 from "../images/carriers/15.png";
import p16 from "../images/carriers/16.png";
import p17 from "../images/carriers/17.png";
import p18 from "../images/carriers/18.png";
import p19 from "../images/carriers/19.png";
import p20 from "../images/carriers/20.png";
import p21 from "../images/carriers/21.png";
import p22 from "../images/carriers/22.png";
import p23 from "../images/carriers/23.png";
import p24 from "../images/carriers/24.png";
import p25 from "../images/carriers/25.png";
import p26 from "../images/carriers/26.png";
import p27 from "../images/carriers/27.png";
import p28 from "../images/carriers/28.png";

function Carriers() {
  return (
    <Layout>
      <div className="carriersContent">
        <div className="carrierTop">
          <div className="carrierTopQuote">
            <h3>
              Chase the vison, not money. The money will end up following you.
            </h3>
            <h2>Tony Hesh</h2>
          </div>
        </div>
        <div className="carrierMiddle">
          <div className="carrierInfo">
            <div className="carrierInfoText">
              <h1>Carriers We Work With</h1>
              <hr></hr>
              <a>
                We only represent A-rated carriers, which means that we work
                with the top carriers in the industry. We have established
                strong relationships with our carriers, and they frequently come
                to train our Associates in person. This provides our team with
                an unparalleled level of knowledge and expertise in the products
                and services that we offer, and allows us to pass that knowledge
                along to our customers. Over and above, you can always find
                Meda-specific bonuses that we draw up special for our team based
                on performance. This commitment to continuous advancement is one
                of the many reasons why MedaHealth is the premier choice for
                insurance professionals.
              </a>
            </div>
          </div>
          <div className="carrierLogoWrapper">
            <div className="carrierLogoContainer">
              <img id="carrierLogos" className="div5" src={p1}></img>
              <img id="carrierLogos" className="div6" src={p2}></img>
              <img id="carrierLogos" className="div7" src={p3}></img>
              <img id="carrierLogos" className="div8" src={p4}></img>
              <img id="carrierLogos" className="div9" src={p5}></img>
              <img id="carrierLogos" className="div10" src={p6}></img>
              <img id="carrierLogos" className="div11" src={p7}></img>
              <img id="carrierLogos" className="div12" src={p8}></img>
              <img id="carrierLogos" className="div13" src={p9}></img>
              <img id="carrierLogos" className="div14" src={p10}></img>
              <img id="carrierLogos" className="div15" src={p11}></img>
              <img id="carrierLogos" className="div16" src={p12}></img>
              <img id="carrierLogos" className="div17" src={p13}></img>
              <img id="carrierLogos" className="div18" src={p14}></img>
              <img id="carrierLogos" className="div19" src={p15}></img>
              <img id="carrierLogos" className="div20" src={p16}></img>
              <img id="carrierLogos" className="div21" src={p17}></img>
              <img id="carrierLogos" className="div22" src={p18}></img>
              <img id="carrierLogos" className="div21" src={p19}></img>
              <img id="carrierLogos" className="div22" src={p20}></img>
              <img id="carrierLogos" className="div5" src={p21}></img>
              <img id="carrierLogos" className="div6" src={p22}></img>
              <img id="carrierLogos" className="div7" src={p23}></img>
              <img id="carrierLogos" className="div8" src={p24}></img>
              <img id="carrierLogos" className="div9" src={p25}></img>
              <img id="carrierLogos" className="div10" src={p26}></img>
              <img id="carrierLogos" className="div11" src={p27}></img>
              <img id="carrierLogos" className="div12" src={p28}></img>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Carriers;
